// Copyright (c) 2017 Deere & Company

import Facets from '../../state/facets';
import LaborAdditivePipsAside from './labor-additive-pips-aside';
import actionCreators from '../../action-creators';
import {connect} from 'react-redux';

const getStateToBindToContainerProps = state => ({
    facets: new Facets({
        ...state.pips.laborAdditive.facets,
        dealerAccountsFacet: {
            ...state.pips.laborAdditive.facets.dealerAccountsFacet,
            allowedDealers: state.user.details.settings.dealer.accounts.selectedAccounts
        }
    }),
    isMoreSummaryVisible: state.pips.laborAdditive.isMoreSummaryVisible,
    isVisible: state.pips.laborAdditive.isVisible,
    laborAdditiveSummaries: state.pips.laborAdditive.laborAdditiveSummaries,
    laborAdditiveSummary: state.pips.laborAdditive.laborAdditiveSummary,
    user: state.user.details
});

const mapBoundActionCreatorsToActionsProp = (stateProps, dispatchProps, parentProps) => {

    const {routeParams} = parentProps;

    return {
        ...stateProps,
        actions: {
            ...dispatchProps
        },
        routeParams
    };

};

export default connect(getStateToBindToContainerProps, actionCreators, mapBoundActionCreatorsToActionsProp)(LaborAdditivePipsAside);



// WEBPACK FOOTER //
// ./src/pip/labor-additive/components/labor-additive-pips-aside/index.js